<template>
  <b-card>
    <b-row>
      <b-col md="12">
        <h2>Upfront Estimates</h2>
      </b-col>
      <template v-if="hasDistanceAndTime">
        <b-col
          md="12"
          class="mb-1"
        >
          <h4>Distance</h4>
          <div
            v-for="(item, ix) in upfrontEstimatesDistance"
            :key="ix"
          >
            {{ item.label }}: <strong>{{ item.value }}</strong>
            <strong class="ml-1">{{ item.source && `( ${item.source} )` }}</strong>
          </div>
        </b-col>
        <b-col md="12">
          <h4>Time</h4>
          <div
            v-for="(item, ix) in upfrontEstimatesTime"
            :key="ix"
          >
            {{ item.label }}: <strong>{{ item.value }}</strong>
            <strong class="ml-1">{{ item.source && `( ${item.source} )` }}</strong>
          </div>
        </b-col>
      </template>
      <template v-if="isUpfrontActive && !hasDistanceAndTime">
        <div>
          <h4 class="ml-1">
            Status:
          </h4>
          <p class="ml-1">
            Upfront estimated is not applied because the actual distance is less than the minimum distance threshold
          </p>
        </div>
      </template>
      <template v-if="!isUpfrontActive && !hasDistanceAndTime">
        <div>
          <h4 class="ml-1">
            Status:
          </h4>
          <p class="ml-1">
            Upfront estimated is disabled on this pricing version
          </p>
        </div>
      </template>
    </b-row>

  </b-card>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'

export default {
  components: { BRow, BCol, BCard },
  props: {
    tripBillDetails: {
      type: Object,
      default: undefined,
    },
  },
  setup(props) {
    const statusFormatter = (source, type) => {
      if (source === 'estimate' && type === 'distance') return 'Within max distance'
      if (source === 'actual' && type === 'distance') return 'Out of the max distance'
      if (source === 'estimate' && type === 'time') return 'Within max time'
      if (source === 'actual' && type === 'time') return 'Out of the max time'
      return ''
    }
    const upfrontEstimates = props.tripBillDetails?.meta?.details?.fare?.details?.upfront_estimates?.details
    const upfrontEstimatesTime = [
      { label: 'Minimum (Minute)', value: (upfrontEstimates?.time?.minimum / 60)?.toFixed(2) },
      { label: 'Maximum (Minute)', value: (upfrontEstimates?.time?.maximum / 60)?.toFixed(2) },
      { label: 'Chosen Time Value (Minute)', value: (upfrontEstimates?.time?.value / 60)?.toFixed(2), source: upfrontEstimates?.time?.source },
      { label: 'Time Status', value: statusFormatter(upfrontEstimates?.time?.source, 'time') },
    ]
    const upfrontEstimatesDistance = [
      { label: 'Minimum (KM)', value: upfrontEstimates?.distance?.minimum },
      { label: 'Maximum (KM)', value: upfrontEstimates?.distance?.maximum },
      { label: 'Chosen Distance Value (KM)', value: (upfrontEstimates?.distance?.value)?.toFixed(2), source: upfrontEstimates?.distance?.source },
      { label: 'Distance Status', value: statusFormatter(upfrontEstimates?.distance?.source, 'distance') },
    ]
    const isUpfrontActive = computed(() => upfrontEstimates?.active)
    const hasDistanceAndTime = computed(() => upfrontEstimates?.distance && upfrontEstimates?.time)
    return {
      upfrontEstimates, upfrontEstimatesTime, upfrontEstimatesDistance, hasDistanceAndTime, isUpfrontActive,
    }
  },
}
</script>

<style>

</style>
